import { render, staticRenderFns } from "./departmentQuestions.vue?vue&type=template&id=58040a36&scoped=true&"
import script from "./departmentQuestions.vue?vue&type=script&lang=js&"
export * from "./departmentQuestions.vue?vue&type=script&lang=js&"
import style0 from "./departmentQuestions.vue?vue&type=style&index=0&id=58040a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58040a36",
  null
  
)

export default component.exports